import type { BadgeProps } from "./badge.type";

import { Badge as AntBadge } from "antd";
import { forwardRef } from "react";

import { useTheme } from "@/services/theme";

export const Badge = forwardRef<HTMLDivElement, BadgeProps>(
  ({ status, ...props }, ref) => {
    const { token } = useTheme();

    if (status === "info") {
      const color = props.color ?? `${token.colorInfo}`;
      return <AntBadge ref={ref} {...props} color={color} />;
    }

    return <AntBadge ref={ref} {...props} status={status} />;
  }
);

Badge.displayName = "Badge";
